Date.isLeapYear = function (year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function (value) {
    let n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};


const getDate = (format = 'y-m-d') => {
    let dt = new Date();

    return formatDate(dt, format);
}


const humanDate = (date) => {
    if (!date) {
        return '';
    }

    // const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    // const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    // const days = ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];
    // const months = ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'];

    let dt;
    let today = new Date();

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    if (today.getFullYear() + today.getMonth() + today.getDate() == dt.getFullYear() + dt.getMonth() + dt.getDate()) {
        return 'Today';
    }

    return `${days[dt.getDay()]}, ${dt.getDate()} ${months[dt.getMonth()]} ${dt.getFullYear()}`;
}


const YMD_HMS = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())} ${pad0(dt.getHours())}:${pad0(dt.getMinutes())}:${pad0(dt.getSeconds())}`;
}

// y-m-d H:i:s
const formatDate = (date, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        // date is string
        // separate date and time
        let [d, t] = date.split(" ");

        let parts = d.split("-");
        if (parts.length < 3) {
            console.log("formatDate: wrong date", date, parts);
            return '';
        }
        if (parts[0].length == 4) { // year comes first
            dt = new Date(date);
        } else {
            dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}` + (t ? ` ${t}` : ''));
        }
    }

    let dateStr = '';
    for (let i = 0; i < format.length; i++) {
        if (format[i] === 'y') {
            dateStr+= dt.getFullYear();
        } else if (format[i] === 'm') {
            dateStr+= pad0(dt.getMonth() + 1);
        } else if (format[i] === 'd') {
            dateStr+= pad0(dt.getDate());
        } else if (format[i] === 'H') {
            dateStr+= pad0(dt.getHours());
        } else if (format[i] === 'i') {
            dateStr+= pad0(dt.getMinutes());
        } else if (format[i] === 's') {
            dateStr+= pad0(dt.getSeconds());
        } else {
            dateStr+= format[i];
        }
    }
     return dateStr;
}

const formatTime = (time) => {
    if (!time) {
        return '';
    }

    let arr = time.split(":");
    return arr[0] + ":" + arr[1];
}

const millisecondsToHours = (milliseconds) => {
    let seconds = Math.floor(Math.abs(milliseconds) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    // hours = hours % 24;
    return `${hours}`.padStart(2, '0') + ':' + `${minutes}`.padStart(2, '0') + ':' + `${seconds}`.padStart(2, '0');
}

const durationString = (milliseconds) => {
    let seconds = Math.floor(Math.abs(milliseconds) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    let str = '';
    if (hours > 0) {
        return `${hours}h` + (minutes > 0 ? `${minutes}m` : '');
    } else {
        return (minutes > 0 ? `${minutes}m` : '') + `${seconds}s`;
    }
}

const pad0 = x => x.toString().padStart(2, "0");

const getTimeFromDate = (dateString) => {
    if (!dateString) {
        return '';
    }

    let datetime = dateString.split(" ");
    return datetime[1] || '';
}


const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};

const copyObjectData = (src, dst, exact = true) => {
    Object.keys(dst).map(key => {
        if (exact) {
            if (dst[key] != undefined)  dst[key] = src[key];
        } else {
            dst[key] = src[key];
        }
    });
}

const copyObjectProperties = (src, dst, properties) => {
    if (!properties) {
        properties = dst;
        dst = {};
    }

    properties.map(item => {
        dst[item] = src[item];
    });

    return dst;
}

const sort = (array, key, descending) => {
    if (descending) {
        return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
    }

    return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}

const setFocusOut = (element_id) => {
    if (!element_id) {
        return;
    }

    let element = document.getElementById(element_id);
    if (element) element.blur();
};

const scrollTo = (element_id) => {
    if (element_id === 'top') {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }
}

const upCaseStr = str => {
    if (!str) {
        return "";
    }
    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}

const getIdFromUrl = (name) => {
    let path = window.location.pathname.split('/');
    let index = path.indexOf(name);
    return path[index + 1] || null;
}


const findNode = (id, array) => {
    let node = null;
    node = array.find(x => x.id == id);
    if (!node) {
        array.map(item => {
            if (!node && item.children && item.children.length) {
                node = findNode(id, item.children);
            }
        })
    }
    return node;
}


export {
    pad0,
    getDate,
    humanDate,
    formatDate,
    formatTime,
    YMD_HMS,
    millisecondsToHours,
    durationString,
    getTimeFromDate,
    copyObject,
    copyObjectData,
    copyObjectProperties,
    sort,
    setFocusTo,
    setFocusOut,
    scrollTo,
    upCaseStr,
    getIdFromUrl,
    findNode
}